import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function PinkBlushRosePage() {
  return <div className="min-h-screen bg-white" data-id="element-1083">
      {/* Header */}
      <Header variant="solid" data-id="element-1084" />

      {/* Hero Section */}
      <section className="relative py-20 px-8 mt-20" data-id="element-1085">
        <div className="max-w-4xl mx-auto" data-id="element-1086">
          {/* Breadcrumb */}
          <div className="text-sm text-neutral-500 mb-6" data-id="element-1087">
            <a href="/blog" className="hover:text-brand-pink transition-colors" data-id="element-1088">
              News & Events
            </a>
            <span className="mx-2" data-id="element-1089">/</span>
            <span className="text-neutral-900" data-id="element-1090">Pink Blush Rosé</span>
          </div>

          {/* Title */}
          <h1 className="font-heading text-4xl lg:text-5xl text-neutral-900 leading-tight mb-6" data-id="element-1091">
            I have three words for you. Pink Blush Rosé. Delve into the life of
            our most popular wine here at Peterson House!
          </h1>

          {/* Featured Image */}
          <div className="relative aspect-[16/9] overflow-hidden bg-gray-300 mb-12" data-id="element-1092">
            <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/landscape-cd-entry-with-wine-wall.jpg" alt="Pink Blush Rosé" className="w-full h-full object-cover" data-id="element-1093" />
          </div>

          {/* Content */}
          <article className="prose prose-lg max-w-none" data-id="element-1094">
            <p className="text-neutral-600 text-lg leading-relaxed mb-8" data-id="element-1095">
              Our Pink Blush Rosé is a semi sweet rosé with fruity notes and a
              clean finish. It's perfection! Now as much as the Pink Blush is
              famous for being delicious, it's also a bottled representation of
              Peterson House as a business - bright, bubbly and perfect for any
              occasion!
            </p>

            {/* Did You Know Section */}
            <div className="bg-brand-pink/10 border-l-4 border-brand-pink p-8 my-8" data-id="element-1096">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1097">
                Did you know?
              </h3>
              <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-1098">
                Our Pink Blush is THE bottle of bubbles that put us on the map!
                Created in 2003/2004, Pink Blush quickly became our most popular
                sparkling wine creating the brand of Peterson House.
              </p>
            </div>

            {/* The Process */}
            <div className="mb-8" data-id="element-1099">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1100">
                The Process
              </h3>
              <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-1101">
                We use the charmat method to retain the fruity fresh characters
                of the wine. This method keeps the wine consistently perfect.
              </p>
            </div>

            {/* The Flavours */}
            <div className="mb-8" data-id="element-1102">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1103">
                The Flavours
              </h3>
              <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-1104">
                The natural acidity of the wine is balanced by a sweeter finish,
                whilst the red wine imparts a full mouthfeel bringing a
                well-rounded experience with every sip. The palate throws hints
                of turkish delight and fairy floss amongst the fruity notes.
              </p>
            </div>

            {/* The Vibe */}
            <div className="mb-8" data-id="element-1105">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1106">
                The Vibe
              </h3>
              <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-1107">
                Our vivacious Pink Blush pairs perfectly with every occasion!
                From a drink with your girlfriends, to celebrating life or
                enjoying delicious food!
              </p>
            </div>

            {/* The Blend */}
            <div className="mb-8" data-id="element-1108">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1109">
                The Blend
              </h3>
              <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-1110">
                Our secret blend combines different white wine varieties, with a
                dash of red wine to complete a delicious sparkling wine! The red
                wine imparts a fresh cut strawberry aroma to the citrus fruit of
                the white wine base.
              </p>
            </div>

            {/* Fun Fact */}
            <div className="bg-neutral-50 p-8 my-8" data-id="element-1111">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1112">
                Fun Fact
              </h3>
              <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-1113">
                The Pink Lady design on the logo was created by a staff member
                on her break! Around the time of creation, long time worker
                Cherine's daughter Tenele (also an employee), 15 at the time,
                was doing her art project on the deck when the manager stopped
                and asked for her to change a few things and re draw it for
                them. The original plan was for a t-shirt and now she is the
                face of our incredible company!
              </p>
            </div>

            {/* Where to Find It */}
            <div className="bg-white border border-neutral-200 p-8 my-12" data-id="element-1114">
              <h3 className="font-heading text-2xl text-neutral-900 mb-6" data-id="element-1115">
                Where to Find Pink Blush Rosé
              </h3>

              <div className="space-y-6" data-id="element-1116">
                <div data-id="element-1117">
                  <h4 className="font-medium text-neutral-900 mb-2" data-id="element-1118">
                    Wine Club
                  </h4>
                  <p className="text-neutral-600 leading-relaxed" data-id="element-1119">
                    Our Pink Blush Rose is the star of our Pink Wine Club
                    Members, with three deliveries of six bottles per year
                    bringing the sparkle to every delivery!
                  </p>
                </div>

                <div data-id="element-1120">
                  <h4 className="font-medium text-neutral-900 mb-2" data-id="element-1121">
                    Restaurant Cuvee
                  </h4>
                  <p className="text-neutral-600 leading-relaxed" data-id="element-1122">
                    Enjoy a glass of Pink Blush bubbles when dining in our
                    restaurant. It's a popular & refreshing glass to start off
                    the day!
                  </p>
                </div>

                <div data-id="element-1123">
                  <h4 className="font-medium text-neutral-900 mb-2" data-id="element-1124">
                    Cellar Door
                  </h4>
                  <p className="text-neutral-600 leading-relaxed" data-id="element-1125">
                    Available as a tasting option, a gift or to take home for
                    yourself in a pack or on its own. You can buy it in a
                    piccolo, 750ml bottle, a magnum, and a special order
                    methuselam! Also available online!
                  </p>
                </div>
              </div>
            </div>

            {/* Closing */}
            <div className="text-center my-12 py-8 border-t border-b border-neutral-200" data-id="element-1126">
              <p className="text-neutral-700 text-lg leading-relaxed mb-4" data-id="element-1127">
                Our Pink Blush Rosé reflects our business in every department,
                and we love sharing it with you all!
              </p>
              <p className="text-brand-pink text-xl font-medium" data-id="element-1128">
                🥂 Cheers Peterson House 🥂
              </p>
            </div>

            {/* Back to Blog */}
            <div className="mt-12" data-id="element-1129">
              <a href="/blog" className="inline-flex items-center gap-2 text-brand-pink hover:text-brand-pink/80 transition-colors font-medium" data-id="element-1130">
                ← Back to News & Events
              </a>
            </div>
          </article>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-1131" />
    </div>;
}